import React, { useState, useEffect } from "react";
import { 
    Paper, 
    withStyles,
    TextField, 
    Button,
} from '@material-ui/core'
import DirectionsRunRoundedIcon from '@material-ui/icons/DirectionsRunRounded'
import Finder from '../components/planfinder'
import {getAllPlans, getSOPS, getProposals} from './db'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import SaveIcon from '@material-ui/icons/Save'
import CssBaseline from '@material-ui/core/CssBaseline'
import Typography from '@material-ui/core/Typography'
import {setSelectedModule, useRedirectToDocs} from '../redux/navigation'
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {useName, useRoles,  setRoles, setName, setAuth, useToken } from '../redux/auth'
import { 
    setPlan, 
    setOpenPlan, 
    setDocs,
} from '../redux/plan'
import Auto from '../components/autocomplete'
import moment from 'moment'
import NewTagDialog from '../components/newtagdialog'
import { theme as theme_ } from "../theme";

const styles = theme => ({
    margin: {
        margin: 10,
    },
    padding: {
        padding: 5
    }
})

const handleLogout = () => {
    setAuth(false)
    setRoles([])
    setName('')
    localStorage.removeItem('session')
    localStorage.removeItem('plan')
    localStorage.removeItem('loginformdata')
  }

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    hide: {
      display: 'none',
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(1),
    },
    completed : {
      backgroundColor: theme_.colors.secondary
    },
    tag: {
        width: '90%',
        paddingLeft: '10%',
        marginBottom:20,
    },
  }))

const Open = () => {
    const [openDialog, setOpenDialog] = useState(false)
    const redirectToDocs = useRedirectToDocs()
    const [plandata, setPlandata] = useState({name:'', company_name:'',process:'', humantags: {}, date:null})
    const name = useName
    const classes = useStyles()
    const [opCre, setOpCre] = useState('')
    const roles = useRoles()
    const token = useToken()
    const {colors} = theme_

    useEffect(() => {
        getAllPlans(token)
        getSOPS(token)
        getProposals(token)
        if(redirectToDocs){
            setSelectedModule('Create')
            setDocs(true)
            setOpenPlan(true)
        }
    }, [])

    const handleClick = (ev) => {
        const target = ev.target.innerHTML
        target.includes('Open plan') ?
            setOpCre('Open plan')
            :
            target.includes('Create plan') ?
                setOpCre('Create plan')
                :
                setOpCre('')
        if(target.includes('Create documents') || target.includes('Documents')){
            setSelectedModule('Create')
            setDocs(true)
            setOpenPlan(true)
        }
    }
    
    const validate = () => {
        plandata.name === '' ? 
            alert('Please write a name for this plan') : 
                plandata.process === '' || plandata.process === null ? 
                    alert('Please write a process for this plan'):
                        handleNewPlan()
    }
    
    const handleNewPlan = () => {
        console.log(plandata)
        getSOPS(token)
        setPlan(plandata)
        setSelectedModule('Find')
        setOpenPlan(true)
    }
    const valName = (name) => {
        const titleRegex = /^[A-Z][A-Za-z0-9]{1,32}_[a-zA-Z0-9_ ]{1,20}_[0-9]{6,6}$/
        if(titleRegex.test(name)){
          return true
        }
        else {
          return false
        }
      }
    const handleFormChange = (event) => {
        let res = {...plandata}
        res[event.target.id]=event.target.value
        if(event.target.id == "company_name")
            res.name = event.target.value + '_' + plandata.humantags?.AR + '_' + moment(plandata.date).format("MMDDYY")
        setPlandata(res)
        localStorage.setItem('localPlan', JSON.stringify(res))
    }
    const updateHumanTag = (tag, x) => {
        let newPlanData = {
            ...plandata,
            humantags:{
                ...plandata?.humantags,
                [tag]:x
            }
        }
        if(tag == "AR")
            newPlanData.name = newPlanData.company_name + '_' + x + '_' + moment(newPlanData.date).format("MMDDYY")
        setPlandata(newPlanData)
        localStorage.setItem('localPlan', JSON.stringify(newPlanData))
    }
    const upProc = (tag, x) => {
        let res = {...plandata}
        res['process']=x
        setPlandata(res)
        localStorage.setItem('localPlan', JSON.stringify(res))
    }
    return(
        <Paper  style={
            opCre === 'Open plan' ? {
                backgroundColor:'rgb(246, 246, 246)',
                width:'100vw',
                height:'auto',
                paddingTop:'1vw'
            } :
            { 
                backgroundColor:'rgb(246, 246, 246)',
                width:'100vw',
                height:'100vh',
                paddingLeft:'32.5vw',
                paddingTop:'6vw'
            }
        }>
            <NewTagDialog isOpen={openDialog} onClose={() => setOpenDialog(false)} docTags={true} /> 
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar)}
                style={{ backgroundColor: colors.primary }}
            >
                <Toolbar style={{ display:'flex', alignItems:'stretch', justifyContent:'space-between' }}>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={() => setOpCre('')}
                    edge="start"
                >
                    <Typography variant="h6" noWrap>
                        Welcome to AutoHACCP {name} 
                    </Typography>
                </IconButton>
                <IconButton
                    onClick={handleLogout}
                    style={{ color: 'white' }}
                >
                    <DirectionsRunRoundedIcon /> 
                    {/* <Typography variant="h6" noWrap>Log Out</Typography>*/}
                </IconButton>
                </Toolbar>
            </AppBar>
            <main className={classes.content}>
                { 
                    opCre === 'Open plan' ?
                        <>
                            <div className={classes.toolbar} />
                            <Finder
                                style={{
                                    width:'100vw',
                                    height:'100vh'
                                }}
                            />
                        </>
                    : 
                        opCre === 'Create plan' ?
                            <Paper
                                style={{ 
                                    width:'30vw',
                                    paddingTop:'1vw',
                                }}
                            >
                                <h1
                                    style={{ 
                                        color: colors.primary
                                    }}
                                >HACCP PLAN</h1>
                    <form noValidate autoComplete="off">
                        <div>
                            <TextField id="name" label="Name" value={plandata.name} 
                            onChange={(e) => handleFormChange(e)} 
                            style={{width:'80%', marginBottom:20}}
                            disabled
                            />
                        </div>
                        <div>
                            <TextField id="company_name" label="Company Name" value={plandata.company_name} 
                            onChange={(e) => handleFormChange(e)} 
                            style={{width:'80%', marginBottom:20}}
                            />
                        </div>
                        <div className={classes.tag}>
                            <Auto 
                                id="AR" 
                                value={plandata.humantags?.AR}
                                type={"Audit Requirements"} 
                                updateProcess={updateHumanTag} 
                                freeSolo={false}
                                tag={'AR'}
                             />
                        </div>
                        <div className={classes.tag}>
                            <Auto 
                                id="LOC" 
                                value={plandata.humantags?.LOC}
                                type={"Location"} 
                                updateProcess={updateHumanTag} 
                                tag={'LOC'}
                             />
                        </div>
                        <div className={classes.tag}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    disableToolbar
                                    variant="inline"
                                    format="MM/dd/yy"
                                    margin="normal"
                                    id="date-picker-inline"
                                    label="Date"
                                    value={plandata.date}
                                    onChange={(date)=>{
                                        setPlandata({
                                            ...plandata, 
                                            date,
                                            name: plandata.company_name + '_' + plandata.humantags?.AR + '_' + moment(date).format("MMDDYY"),
                                        })
                                        localStorage.setItem('localPlan', JSON.stringify({...plandata, date}))
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{width:'100%'}}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className={classes.tag}>
                            <Auto 
                                id="process" 
                                label="Process" 
                                value={plandata.process} 
                                tag={'PR'}
                                updateProcess={upProc} 
                                type={'Process'}
                            />
                        </div>
                        <Button
                             variant="contained"
                             style={{ 
                                 backgroundColor: colors.primary, 
                                 color: colors.light,
                                 margin:20
                             }}
                                id='createNewPlan'
                                onClick={validate}
                            >
                                Create!
                            </Button>
                        <Button
                             variant="contained"
                             style={{ 
                                 backgroundColor: colors.secondary, 
                                 color : colors.light ,
                                 margin:20
                             }}
                                id='new_tag'
                                onClick={() => setOpenDialog(true)}
                            >
                                New Tag
                        </Button>
                    </form>
                            </Paper>
                        :
                        <Paper 
                            style={{ 
                                width:'30vw',
                                height:300,
                                padding: 30,
                                backgroundImage:<SaveIcon style={{ 
                                    color: 'rgba(76, 194, 208, .6)',
                                    fontsize: 60
                                }}/>
                            }}
                        >
                            
                            <h1
                                style={{ 
                                    color: colors.primary
                                }}
                            >What would you like to do?</h1>
                            <Button
                             variant="contained"
                             style={{ 
                                 backgroundColor: colors.secondary, 
                                 color:'white',
                                 margin:20
                             }}
                                id='open'
                                onClick={handleClick}
                            >
                                Open plan
                            </Button>
                            <Button
                            variant="contained"
                            style={{ 
                                backgroundColor: colors.secondary, 
                                color:'white',
                                margin:20
                            }}
                                id='create'
                                onClick={handleClick}
                            >
                                Create plan
                            </Button>
                            { roles.includes('admin') ?
                                <Button
                                variant="contained"
                                style={{ 
                                    backgroundColor: colors.secondary, 
                                    color:'white',
                                    margin:20
                                }}
                                    id='create'
                                    onClick={handleClick}
                                >
                                    Documents
                                </Button>
                            :
                                <Button
                                variant="contained"
                                style={{ 
                                    backgroundColor: colors.secondary, 
                                    color:'white',
                                    margin:20
                                }}
                                    id='create'
                                    onClick={handleClick}
                                >
                                    Create documents
                                </Button>
                            }
                        </Paper>
                }
            </main>
        
        </Paper>
    )
}

export default withStyles(styles)(Open)